import React from "react";

import Box from "@mui/material/Box";

import CustomButton from "../Utils/Custom_Btn";
const MainHeader=({title,onNavigate })=>{
  return(
    <Box
      sx={{
        display: {lg:"flex"},
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
      }}
    >
    <Box
      sx={{
        display: {md:"flex"},
        gap: "20px",
        alignItems: "center",
      }}
    >
      <CustomButton 
        onNavigate ={onNavigate} 
        title={title} 
      />
      
    </Box>

  </Box>
  )
}
export default MainHeader